module.exports = __webpack_public_path__ + "ptc_momoro_B2.01fe630b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_B2.jpg
// module id = GEky
// module chunks = 0